import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Search Component
 *
 * A reusable search input with icon.
 *
 * @example
 * ```html
 * <app-atom-search
 *   placeholder="Search users..."
 *   [value]="searchQuery"
 *   (valueChange)="onSearch($event)">
 * </app-atom-search>
 * ```
 */
@Component({
  selector: 'app-atom-search',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="atom-search flex items-center w-full border border-gray-200 bg-gray-50 rounded-xl px-4 py-2 text-sm focus-within:border-blue-400 transition"
    >
      <i class="ti-search text-gray-400 mr-2 text-lg"></i>
      <input
        class="flex-1 bg-transparent outline-none border-none text-sm placeholder:text-gray-400"
        [attr.placeholder]="placeholder()"
        [value]="value()"
        [disabled]="disabled()"
        (input)="onInput($event)"
        type="text"
      />
    </div>
  `,
})
export class SearchComponent {
  // Inputs using signal-based API
  placeholder = input<string>('Search...');
  value = input<string>('');
  disabled = input<boolean>(false);

  // Output using signal-based API
  valueChange = output<string>();

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.valueChange.emit(target.value);
  }
}
